import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

const PaxDetails = ({ pax, titles, className }) => {
  let result = "";
  if (pax.Adults) {
    result += `${pax.Adults} ${titles.Adults}`;
  }
  if (pax.Children) {
    result += `, ${pax.Children} ${titles.Children}`;
  }
  if (pax.Infants) {
    result += `, ${pax.Infants} ${titles.Infants}`;
  }

  return <div className={cx(styles.paxDetails, className)}>{result}</div>;
};

PaxDetails.propTypes = {
  className: PropTypes.string,
  pax: PropTypes.object,
  titles: PropTypes.object
};

export default PaxDetails;



// WEBPACK FOOTER //
// ./src/components/Cart/Rooms/Room/RoomBody/PaxDetails/PaxDetails.js